/**
 * Referral program — frontend constants.
 *
 * Reward AMOUNTS are deliberately NOT defined here — they are owned by the
 * server (server/src/config/referral.ts) and arrive via the /api/referral
 * endpoints, so the two sides can never drift.
 */

/** URL query param on a shared link: app.todowith.ai/?ref=CODE */
export const REFERRAL_QUERY_PARAM = "ref";

/** Path prefix for the dedicated referral landing page: /r/CODE */
export const REFERRAL_ROUTE_PREFIX = "/r";

/** localStorage key holding a captured referral code until signup consumes it. */
export const REFERRAL_STORAGE_KEY = "flowly.referral.pendingCode";

/** localStorage key holding the ISO timestamp of the most recent referral
 *  reward the user has already seen a celebration toast for. */
export const REFERRAL_SEEN_REWARD_KEY = "flowly.referral.lastSeenRewardAt";

/** Window event dispatched after a referee bonus is granted, so CreditsContext
 *  re-fetches the (now higher) balance. */
export const REFERRAL_BONUS_GRANTED_EVENT = "referral:bonus-granted";

/** Where a freshly-signed-up referee lands after signup: straight into a
 *  creation flow, to activate them at the peak moment. */
export const POST_SIGNUP_REDIRECT = "/generate-product-catalog";

/** Build a shareable referral link for the given code. */
export function buildReferralLink(code: string): string {
  return `${window.location.origin}${REFERRAL_ROUTE_PREFIX}/${code}`;
}
